<template>
    <section class="inline large">
        <div class="grid xs-grid-cols-1 gap-3 fixed fixed-max-sm">
            <schoolsTable :data="data.district.schools" />
            <div>
                School data provided by
                <a class="link" href="https://www.greatschools.org/" rel="nofollow">GreatSchools.org</a>.
                See a school you’re interested in? Get matched with a top local Real Estate agent and start touring homes nearby.
            </div>
        </div>
    </section>
</template>

<script src="./schools-district.js"></script>

<style lang="scss">
@use './schools-district.scss' as *;
</style>
